export const getBlockStyles = (block, templates) => {
    const styles = {}
    if (templates.isOpen && templates.selectedBlockMeta && templates.selectedBlockMeta.t === block.t) {
        styles.borderColor = block.color
    }
    return styles
}
